import { generateLocalStorage } from "react-better-html";

import { type FirebaseUser, type User } from "../types/user";
import { type Organization } from "../types/organization";
import { type PropertyFull } from "../types/property";
import { type Workspace } from "../types/workspace";

export const LocalStorage = generateLocalStorage<{
   firebaseUser: FirebaseUser;
   firebaseUserIdToken: string;
   user: User;
   organizations: Organization[];
   selectedOrganizationId: Organization["id"];
   properties: PropertyFull[];
   workspaces: Workspace[];
}>();
